import * as THREE from 'three';

type SceneCameraControllerOptions = {
  distance: number;
  angleDegrees: number;
  minAngleDegrees?: number;
  maxAngleDegrees?: number;
};

const origin = new THREE.Vector3(8, 0, 13.5);

export class SceneCameraController {
  private readonly distance: number;
  private readonly minAngleDegrees: number;
  private readonly maxAngleDegrees: number;
  private angleDegrees: number;

  constructor(
    private readonly camera: THREE.PerspectiveCamera,
    options: SceneCameraControllerOptions,
  ) {
    this.distance = options.distance;
    this.minAngleDegrees = options.minAngleDegrees ?? 1;
    this.maxAngleDegrees = options.maxAngleDegrees ?? 89;
    this.angleDegrees = options.angleDegrees;
    this.applyAngle();
  }

  setAngleDegrees(angleDegrees: number) {
    this.angleDegrees = angleDegrees;
    this.applyAngle();
  }

  getAngleDegrees() {
    return this.angleDegrees;
  }

  setViewportSize(width: number, height: number) {
    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
  }

  private applyAngle() {
    const clampedAngle = THREE.MathUtils.clamp(
      this.angleDegrees,
      this.minAngleDegrees,
      this.maxAngleDegrees,
    );
    this.angleDegrees = clampedAngle;

    const angleRadians = THREE.MathUtils.degToRad(clampedAngle);
    const y = Math.sin(angleRadians) * this.distance;
    const z = -Math.cos(angleRadians) * this.distance;

    this.camera.position.copy(origin).add(new THREE.Vector3(0, y, z));
    this.camera.lookAt(origin);
    this.camera.updateProjectionMatrix();
  }
}
